import useAuth from "@/hooks/useAuth";
import useStoresList from "@/hooks/useStoresList";
import useLang from "@/hooks/useLang";
import useStore from "@/hooks/useStore";
import useTranslation from "@/hooks/useTranslation";
import type { TyStoreMembership } from "@/types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";

type TyStoreListItem = TyStoreMembership;

export default function SelectStoreScreen() {
    const t = useTranslation();
    const lang = useLang((state) => state.lang);
    const navigate = useNavigate();
    const token = useAuth((state) => state.token);
    const setStore = useStore((state) => state.setStore);

    const [selectedId, setSelectedId] = useState<string | null>(null);

    const { stores } = useStoresList();

    useEffect(() => {
        if (!token) navigate("/login", { replace: true });
    }, [token, navigate]);

    const getStoreName = (store: TyStoreListItem): string => {
        const match = store.name.find((n) => n.lang === lang) ?? store.name[0];
        return match?.value ?? "—";
    };

    const handleConfirm = () => {
        const store = stores.find((s) => s._id === selectedId);
        if (!store) return;
        setStore(store._id, store);
        navigate("/");
    };

    return (
        <div className="select-store">
            <div className="select-store-card">
                <img src="/logo-mini-round.svg" className="select-store-logo" alt="Menuket" />
                <div className="select-store-header">
                    <p className="select-store-title">{t.selectStore.title}</p>
                    <p className="select-store-subtitle">{t.selectStore.subtitle}</p>
                </div>

                <div className="select-store-list">
                    {stores.map((store) => {
                        const name = getStoreName(store);
                        return (
                            <button
                                key={store._id}
                                type="button"
                                className={`select-store-row${selectedId === store._id ? " select-store-row--selected" : ""}`}
                                onClick={() => setSelectedId(store._id)}
                            >
                                <div className="select-store-row-logo">
                                    {store.logo ? <img src={store.logo} alt={name} /> : <span>{name.charAt(0)}</span>}
                                </div>
                                <p className="select-store-row-name">{name}</p>
                            </button>
                        );
                    })}
                </div>

                <div className="select-store-actions">
                    <button type="button" className="select-store-new" onClick={() => navigate("/create-store")}>
                        <img src="/icons/plus-gray-icon.svg" alt="" />
                        {t.selectStore.newStoreButton}
                    </button>
                    <button type="button" className="select-store-confirm" onClick={handleConfirm} disabled={!selectedId}>
                        {t.selectStore.selectButton}
                    </button>
                </div>
            </div>
        </div>
    );
}
